import z from 'zod';
import { COUNTRY_CODE_REGEX } from '../../utils/constants';
export const LanguageSchema = z.object({
    id: z.string().regex(COUNTRY_CODE_REGEX, { message: 'invalid_language_id' }).optional(),
    name: z.string().optional()
});
//# sourceMappingURL=languageSchema.js.map